// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__183Cb","label":"Completed_label__21cAL"};